import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import { wordFormByCount } from 'utils/formatting';

import FiveStar from './img/full-star.svg';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * ProductDetails Layout for FeedbackLink component
 * used both in page View and CrossSellPopup Widget
 */
export default function FeedbackWidgetLayout({
  className,
  feedbackUrl,
  hasFeedback,
  isCompact,
  onFeedbackClick,
  rateCount,
  rateFill,
}) {
  return hasFeedback ?
      <div className={cx('component', { compact: isCompact }, className)}>
        <a className={cx('link')} href={feedbackUrl} onClick={onFeedbackClick}>
          <span className={cx('rateFill')}>{rateFill}</span>
          <span className={cx('rateWrapper')}>
            <FiveStar />
          </span>
          <div className={cx('sumAction')}>
            <span>
              {rateCount} {wordFormByCount(rateCount, ['отзыв', 'отзыва', 'отзывов'])}
            </span>
          </div>
        </a>
      </div>
    : null;
}

FeedbackWidgetLayout.propTypes = {
  className: PropTypes.string,
  feedbackUrl: PropTypes.string, // required for seo
  hasFeedback: PropTypes.bool,
  isCompact: PropTypes.bool,
  onFeedbackClick: PropTypes.func,
  rateCount: PropTypes.number,
  rateFill: PropTypes.number,
};
